module.exports = __webpack_public_path__ + "img/s8Bg12.fa34716f.jpg";